export default __webpack_public_path__ + "static/media/image.ourfuture-lk.b10e046f.png";